module.exports = __webpack_public_path__ + "media/fr_fr_s3_Lisette.d19bf98a.mp3";